<ion-row *ngIf="data?.percentages?.length > 0">
  <div
    *ngFor="let item of data?.percentages; let i = index"
    class="row-list-text"
  >
    <div *ngIf="item?.percentage" [attr.data-cy]="item?.dataCy">
      <div *appShowSplit="[item?.displayFlag]">
        <h1 [attr.data-cy]="item?.dataCy + '-percentage'">
          {{ item?.percentage }}%
        </h1>
        <div class="title-container" [attr.data-cy]="item?.dataCy + '-title'">
          {{ item?.title }}
          <ng-container
            *ngIf="(platformService?.isTouchExperience$ | async) === false"
          >
            <ion-icon
              name="information-circle-outline"
              color="primary"
              [id]="'hover-trigger-' + i"
              [attr.data-cy]="'info-icon-hover-' + i"
            ></ion-icon>
            <!-- Desktop/Non-touch: Hover trigger -->
            <ion-popover
              *ngIf="(platformService?.isTouchExperience$ | async) === false"
              mode="ios"
              [trigger]="'hover-trigger-' + i"
              triggerAction="hover"
              [attr.data-cy]="'info-popover-hover-' + i"
            >
              <ng-template>
                <ion-content
                  class="ion-padding"
                  data-cy="info-popover-content"
                  >{{
                    'i18n.orderInsightsPage.cookbookAdoptionTooltip' | translate
                  }}</ion-content
                >
              </ng-template>
            </ion-popover>
          </ng-container>
          <ng-container
            *ngIf="(platformService?.isTouchExperience$ | async) === true"
          >
            <ion-icon
              name="information-circle-outline"
              color="primary"
              [id]="'click-trigger-' + i"
              [attr.data-cy]="'info-icon-click-' + i"
            ></ion-icon>
            <!-- Touch: Click trigger -->
            <ion-popover
              *ngIf="platformService?.isTouchExperience$ | async"
              mode="ios"
              [trigger]="'click-trigger-' + i"
              triggerAction="click"
              [attr.data-cy]="'info-popover-click-' + i"
            >
              <ng-template>
                <ion-content
                  class="ion-padding"
                  data-cy="info-popover-content"
                  >{{
                    'i18n.orderInsightsPage.cookbookAdoptionTooltip' | translate
                  }}</ion-content
                >
              </ng-template>
            </ion-popover>
          </ng-container>
        </div>
      </div>
      <div
        *ngIf="data?.lineDivider && i < data?.percentages.length - 1"
        class="line-divider"
      ></div>
    </div>
  </div>
</ion-row>
